import { render } from "./MiniBaziAdvicePanel.vue?vue&type=template&id=42ec1a9a&scoped=true"
import script from "./MiniBaziAdvicePanel.vue?vue&type=script&lang=js"
export * from "./MiniBaziAdvicePanel.vue?vue&type=script&lang=js"

import "./MiniBaziAdvicePanel.vue?vue&type=style&index=0&id=42ec1a9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ec1a9a"]])

export default __exports__